import DataSource from "../DataSource";

export default class PoziadavkaService {

  constructor(server, PrilohaService) {
    this.server = server;
    this.PrilohaService = PrilohaService;
  }

  get(poziadavkaId) {
    if(poziadavkaId) {
      return this.server("Poziadavka.read", {id: poziadavkaId});
    }else {
      return Promise.resolve({id: 0})
    }
  }

  save(poziadavka) {
    if (poziadavka.id === 0)
      return this.server("Poziadavka.create", poziadavka);
    else
      return this.server("Poziadavka.update", poziadavka);
  }

  close(poziadavka) {
    return this.server("Poziadavka.close", poziadavka);
  }

  changeState(poziadavka) {
    return this.server("Poziadavka.changeState", poziadavka);
  }

  assignTechnician(poziadavka) {
    return this.server("Poziadavka.assignTechnician", poziadavka);
  }

  addPoznamka(poznamka) {
    return this.PrilohaService.serializePrilohy(poznamka.prilohy)
    .then(prilohy => ({...poznamka, prilohy:prilohy}))
    .then(poznamka => this.server("Poznamka.create", poznamka));
  }

  list(filter, order) {
    return this.server("Poziadavka.list", {order: order, filter: filter});
  }

  getTypes() {
    return this.server("TypPoziadavky.list", {order: {}, filter: {}}).then(x => x.result);
  }

  notify(id, email, text){
    return this.server("Poziadavka.notify", {id: id, email: email, text: text});
  }

  getListSource(config){
    return new DataSource(this.server, "Poziadavka.list", config);
  }
}


// WEBPACK FOOTER //
// ./src/poziadavky/PoziadavkaService.js